import { useEffect } from 'react'
import Footer from "./Footer"
import Header from "./Header"

import AuthenicatedLayout from './AuthenticatedLayout'
import UnauthenicatedLayout from './UnauthenticatedLayout'
import NoProfileLayout from './NoProfileLayout'

export default function Layout({userFullName, authenticated = false, userProfile = undefined}) {
  useEffect(() => {

  })

  return (
    <div>
      <Header
            userFullName={userFullName}
            appName={<div style={{
              height: '46px',
              padding: '5px'
              }}>
                <span className="logo-lg">NAOU&nbsp;QSE&nbsp;Portal</span>
              </div>}
              authenticated={authenticated}
            />
        {authenticated && <>
          
          { userProfile && <AuthenicatedLayout /> }
          { !userProfile && <NoProfileLayout /> }
        </>}
        { !authenticated && <UnauthenicatedLayout /> }
      <Footer version = "1.2.0" />
    </div>
  )
}